export default __webpack_public_path__ + "static/media/logo.9869a536.png";